export function PAP_Upload_SignDocument(properties) {
    return {
        class: 'sign',
        action: 'upload',
        object: 'sign_document',
        properties,
    };
}
//# sourceMappingURL=upload_sign_document.js.map